'use strict';

export default class CancelZoom {
  constructor(options) {
    console.log('CancelZoom module');

    const defaults = {
        cancelableElens: 'input:text,select,textarea'
    };

    this.options = Object.assign({}, defaults, options);

    this.actualMetaValue;

  }

  _autoEnableDisable() {
    $(this.options.cancelableElens).each(this._cancelZoom);
  }

  _saveActualMeta() {

    this.actualMetaValue = $('meta[name=viewport]').attr('content');

  }

  _disableZoom() {
    console.warn('disabling page zoom');

    $('meta[name=viewport]').attr('content','width=device-width,initial-scale=1,maximum-scale=1.0');

    return this;

  }

  _resetMeta() {
    console.warn('reseting page zoom');

    $('meta[name=viewport]').attr('content', this.actualMetaValue);

    return this;

  }

  _cancelZoom() {
    let d = document,
        viewport,
        content,
        maxScale = ',maximum-scale=',
        maxScaleRegex = /,*maximum\-scale\=\d*\.*\d*/;

    // this should be a focusable DOM Element
    if(!this.addEventListener || !d.querySelector) {
        return;
    }

    viewport = d.querySelector('meta[name="viewport"]');
    content = viewport.content;

    function changeViewport(event)
    {
        // http://nerd.vasilis.nl/prevent-ios-from-zooming-onfocus/
        viewport.content = content + (event.type == 'blur' ? (content.match(maxScaleRegex, '') ? '' : maxScale + 10) : maxScale + 1);
    }

    // We could use DOMFocusIn here, but it's deprecated.
    this.addEventListener('focus', changeViewport, true);
    this.addEventListener('blur', changeViewport, false);
  }
}